import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

const SCROLL_AMOUNT = 268 + 16; // card width + half of the gap between cards

export const useSupportScrolling = (mainElement: HTMLElement | null, cardsCount: number) => {
  const [scrollState, setScrollState] = useState({ canScrollLeft: false, canScrollRight: false });

  const refreshScrollState = useDebouncedCallback(() => {
    if (!mainElement) {
      setScrollState({ canScrollLeft: false, canScrollRight: false });
      return;
    }

    const canScrollLeft = mainElement.scrollLeft > 0;
    const canScrollRight =
      mainElement.scrollLeft < mainElement.scrollWidth - mainElement.clientWidth;

    setScrollState({ canScrollLeft, canScrollRight });
  }, 100);

  const handleScrollLeft = () => {
    if (!mainElement) {
      return;
    }

    mainElement.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
  };

  const handleScrollRight = () => {
    if (!mainElement) {
      return;
    }

    mainElement.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
  };

  // track cards count change, so we can adjust buttons actitivy
  useEffect(() => {
    refreshScrollState();
  }, [refreshScrollState, cardsCount]);

  // track container scrolling, so we can adjust buttons actitivy
  useEffect(() => {
    if (!mainElement) {
      return;
    }

    mainElement.addEventListener('scroll', refreshScrollState);
    return () => {
      mainElement.removeEventListener('scroll', refreshScrollState);
    };
  }, [mainElement, refreshScrollState]);

  return { scrollState, handleScrollLeft, handleScrollRight };
};
